var render = function render(){var _vm=this,_c=_vm._self._c;return _c('toolbar',[_c('h2',[_c('i',{staticClass:"fa fa-tags"}),_vm._v(" "+_vm._s(_vm.title))]),_c('div',{staticClass:"controls"},[_vm._t("default"),_c('nav-tabs',{attrs:{"tabs":_vm.tabs,"addon-apps-location":"Materials Module","addon-apps-link":"/materials/apps"}})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }